const SAGGIO = 'SAGGIO';
const OMAGGIO = 'OMAGGIO';
// const ACTIVATED = 'ACTIVATED';

export const BookTypes = {
    SAGGIO,
    OMAGGIO,
    // ACTIVATED,
};
